import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import styles from "./HomePage.module.css";
import FeedList from "../components/FeedList";

const HomePage: React.FC = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState("전체");
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const handleCreatePost = () => {
    if (!currentUser) {
      navigate("/login");
      return;
    }
    navigate("/create-feed");
  };

  // 스크롤 이벤트 핸들러
  useEffect(() => {
    const handleScroll = () => {
      const scrollContainer = scrollContainerRef.current;
      if (!scrollContainer) return;

      const currentScrollY = scrollContainer.scrollTop;

      // 스크롤 방향 감지
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        // 아래로 스크롤하고 50px 이상 스크롤한 경우 헤더 숨김
        setIsHeaderVisible(false);
      } else if (currentScrollY < lastScrollY) {
        // 위로 스크롤하는 경우 헤더 표시
        setIsHeaderVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll, {
        passive: true,
      });

      return () => {
        scrollContainer.removeEventListener("scroll", handleScroll);
      };
    }
  }, [lastScrollY]);

  return (
    <div className={styles.homePage}>
      <div
        className={`${styles.topContainer} ${
          isHeaderVisible ? styles.topVisible : styles.topHidden
        }`}
      >
        <header className={styles.appHeader}>
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/main-logo.png`}
            alt="PetMilly Logo"
            className={styles.logoImage}
          />
        </header>

        <div className={styles.stickyContainer}>
          <div className={styles.searchContainer}>
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/tag-search.svg`}
              alt="Search"
              className={styles.searchIcon}
            />
            <input type="text" placeholder="해시태그를 검색해 보세요" />
          </div>
          <div className={styles.categoryMenu}>
            <button
              className={`${styles.categoryItem} ${
                activeCategory === "전체" ? styles.active : ""
              }`}
              onClick={() => setActiveCategory("전체")}
            >
              전체
            </button>
            <button
              className={`${styles.categoryItem} ${
                activeCategory === "내피드" ? styles.active : ""
              }`}
              onClick={() => setActiveCategory("내피드")}
            >
              내피드
            </button>
            <button
              className={`${styles.categoryItem} ${
                activeCategory === "펫밀리피드" ? styles.active : ""
              }`}
              onClick={() => setActiveCategory("펫밀리피드")}
            >
              펫밀리피드
            </button>
          </div>
        </div>
      </div>

      <div className={styles.homeContent} ref={scrollContainerRef}>
        <FeedList
          key={activeCategory}
          category={
            activeCategory === "전체"
              ? "all"
              : activeCategory === "내피드"
              ? "user"
              : "petmilly"
          }
        />
      </div>

      {/* 플로팅 + 버튼 */}
      <button className={styles.floatingButton} onClick={handleCreatePost}>
        <div className={styles.plusIcon}>+</div>
      </button>
    </div>
  );
};

export default HomePage;
